// extracted by mini-css-extract-plugin
export default {"customScroll":"popup_customScroll__uqPdY","container":"popup_container__w4dR1"};